import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-po-failed-modal',
  templateUrl: './po-failed-modal.component.html',
  styleUrls: ['./po-failed-modal.component.scss']
})
export class PoFailedModalComponent implements OnInit {

  public title!: string;
  public error!: any;
  public successMsg: string = "Create Purchase Order";
  public isSuccess: boolean = false;
  public success: any;
  public successError: any;
  public message!: string[];
  public errorTypes: string[] = []; // Array to store the types

  constructor(public bsModalRef: BsModalRef) {}

  ngOnInit(): void {
    let value = this.successError.data.sapResponse;
    this.message = value.map((item: any) => item.MESSAGE);
    this.errorTypes = value.map((item: any) => item.TYPE); // Store the types

    if (this.error && this.error.exception) {
      this.error.exception = eval(this.error?.exception);
      this.isSuccess = this.error.exception?.filter((message: any) => message.MESSAGE.includes(this.successMsg)).length == this.error.exception.length;
    } else {
      this.isSuccess = this.message.length == 1 && this.message[0].includes(this.successMsg);
    }
  }

  public getMessageClass(type: string): string {
    switch (type) {
      case 'E':
        return 'text-danger';
      case 'A':
        return 'text-danger';
      case 'I':
        return 'text-information';   
      case 'W':
        return 'text-warning';
      default:
        return '';
    }
  }

  public onModalClose(): void {
    this.bsModalRef.hide();
  }
}
